import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { BottomNav } from "./BottomNav";
import { CommandPalette } from "./CommandPalette";
import { InstallBanner } from "@/components/InstallApp";

export function AdminLayout({ children }: { children: ReactNode }) {
  const location = useLocation();
  return (
    // h-[100dvh]: su iOS la barra del browser fa ballare 100vh e il fondo
    // della pagina finisce sotto la chrome di Safari.
    <div className="flex h-screen h-[100dvh] overflow-hidden bg-background">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar />
        <main className="scroll-touch flex min-w-0 flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <div
            className="flex h-full min-h-0 w-full max-w-full flex-col p-3 sm:p-4 md:p-6"
            style={{ paddingBottom: "var(--page-pb)" }}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={location.pathname}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{
                  opacity: 0,
                  y: -4,
                  transition: { duration: 0.15, ease: [0.16, 1, 0.3, 1] },
                }}
                transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
                className="flex h-full min-h-0 w-full min-w-0 max-w-full flex-col"
              >
                {children}
              </motion.div>
            </AnimatePresence>
          </div>
        </main>
      </div>
      <BottomNav />
      <InstallBanner />
      <CommandPalette />
    </div>
  );
}
